import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getReportedMedia } from "../../store/reducers/reports.reducer";
import { useReportedMedia } from "./useReportedMedia";
import { useKeycloak } from "@react-keycloak/web";

export const useGetReportedMedia = () => {
    const { keycloak } = useKeycloak();
    const dispatch = useDispatch();

    useEffect(() => {
        if (keycloak.token) {
            dispatch(getReportedMedia(keycloak.token));
        }
    }, [dispatch, keycloak.token]);

    return useReportedMedia();
}